module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-rating-content-horror.d3a4e071.svg";